import React from 'react'
import { CdnImage, CdnPath, StaticImage } from '../shared/cdn-image'


const SPECIAL_CHARS_REGEX = /[&\-_!@%$#*]/;
const DIGIT_REGEX = /[0-9]/;
const UPPER_CASE_REGEX = /[A-Z]/;
const LOWER_CASE_REGEX = /[a-z]/;
const NUM_SPECIAL_CHARS_REGEX = /[0-9&\-_!@%$#*]/;

const principles =  [
	{
		label: "8 or more characters",
		predicate: password => password.length >= 8
	},
	{
		label: "At least one number or one of the following:  & - ! @ % $ # *",
		predicate: password => password.match(NUM_SPECIAL_CHARS_REGEX) !== null
	}
];

const strength = {
  0: "Weak",
  1: "Bad",
  2: "Fair",
  3: "Good",
  4: "Strong"
}

const colour = {
	0: "primary",
	1: "primary",
	2: "dark-green",
	3: "dark-green",
	4: "dark-green"
}

class StrengthMeter extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			password: '',
			isPasswordShown: false,
			isMeterShown: false,
		};
	}

 	togglePasswordVisibility = () => {
		this.setState({isPasswordShown : !this.state.isPasswordShown });
 	}

	handleChange = (event) => {
		if( this.state.password.length > 0 ){
			this.setState({isMeterShown: true });
		}
		this.setState({ password: event.target.value}, function() {
			this.props.handleChange( this.state.password, this.isValid() );
		});
	}

	score = () => {

		let password = this.state.password;

		if( password === '' || password == null ){
			return 0;
		}

		if( password.length < 3 ){
			return 0;
		}

		let score = 0;

		if( password.match(DIGIT_REGEX) !== null ){
			score += 1;
		}

		if( password.match(UPPER_CASE_REGEX) !== null && password.match(LOWER_CASE_REGEX) !== null ){
			score += 1;
		}

		if( password.match(SPECIAL_CHARS_REGEX) !== null ){
			score += 1;
		}

		if( password.length >= 8 ) {
			score += 1;
		} else {
			score = 1;
		}

		//stop overflow
		if( score > strength.length-1 ){
			score = strength.length-1;
		}

		return score;

	}

	strength = () => {
		return strength[this.score()];
	}

	colour = () => {
		return colour[this.score()];
	}

	principleSatisfied = (principle) => {
		return principle.predicate( this.state.password );
	}

	principleStyle = (principle) => {
		let satisfied = this.principleSatisfied(principle);
		if( satisfied ) {
			return { fontWeight: '700', color: 'darkgreen' };
		} else {
			return { fontWeight: '700', color: 'red' };
		}
  }


	isValid = () => {

		const score = this.score();

		let allPrinciplePassed = true;

		principles.map( ( principle, index ) => {
			if( !this.principleSatisfied( principle ) ) {
				allPrinciplePassed = false;
			}
		});

		if( score >= 0 && allPrinciplePassed ) {
			return true
		} else {
			return false;
		}
	}

	render() {

		return (
			<>
				<label>Your new Password</label>
				<div className="form-password">
					<div onClick={this.toggleMeterVisibility}>
						<input
							type={(this.state.isPasswordShown) ? "text" : "password"}
							name="password"
							placeholder={this.props.placeholder}
							className="form-input radius"
							onChange={this.handleChange} 
						/>
					</div>
					{(this.state.isMeterShown) ? 
						<div className={this.colour() + " border thick radius pd mg-b"}>
							<p className="mg-b">Password strength: <span className={this.colour() + " bold"}>{this.strength()}</span></p>
							<meter min="0" low="0" optimum="3" high="2" max="4" value={this.score()} style={{width: '100%'}}></meter>
							
							<h5 className="mg-t-sm">Your password must have:</h5>
	
							<ul>
								{principles.map(principle =>
								<li className="mg-b-sm" key={principle.label} style={this.principleStyle(principle)}>
									<i className="fa fa-check"></i> {principle.label}
								</li>
								)}
							</ul>
						</div>
					: null }
					<div onClick={this.togglePasswordVisibility}>
						{(this.state.isPasswordShown) ? <span className="icon icon-show black"></span> : <span className="icon icon-hide black"></span>}
					</div>
				</div>
			</>
		)
		
	}
}

export default StrengthMeter;
